import { getCoreRowModel, useReactTable } from "@tanstack/react-table";
import { useTranslate } from "@tolgee/react";
import { useMemo } from "react";
import { VirtualizedGridTable } from "#/components/ui/virtualized-grid-table";
import { useHyperOpenOrders } from "#/hooks/use-hyperliquid-account";
import {
	createPortfolioOpenOrderColumns,
	type PortfolioOpenOrderRow,
} from "./open-orders-columns";

const GRID_CLASS =
	"grid min-w-[640px] grid-cols-[1.2fr_0.7fr_0.9fr_0.9fr_0.9fr] gap-3";

const coreRowModel = getCoreRowModel();

export function OpenOrdersTable() {
	const { t } = useTranslate();
	const { openOrders, isError, refetch } = useHyperOpenOrders();
	const columns = useMemo(() => createPortfolioOpenOrderColumns(t), [t]);

	const table = useReactTable<PortfolioOpenOrderRow>({
		data: openOrders,
		columns,
		getCoreRowModel: coreRowModel,
		enableSorting: false,
	});

	return (
		<div className="min-w-0">
			<h2 className="mb-4 text-body2-bold text-foreground">
				{t("portfolio.open-orders")}
			</h2>
			{/* Bounded height reserves space so the loading/empty→rows transition
			    doesn't shift the tables below it (portfolio CLS). */}
			<div className="flex min-h-48 max-h-80 flex-col">
				<VirtualizedGridTable
					table={table}
					gridClass={GRID_CLASS}
					estimateSize={36}
					emptyMessage={t("portfolio.no-orders")}
					isError={isError}
					onRetry={() => {
						refetch();
					}}
				/>
			</div>
		</div>
	);
}
